import Vue from 'vue'
import axios from 'axios'
// import router from '@/router'
import merge from 'lodash/merge'
// import { clearLoginInfo } from '@/utils'
import qs from 'qs'
// import de from 'element-ui/src/locale/lang/de'
// import { Message, Loading } from 'element-ui'

const service = axios.create({
  baseURL: process.env.BASE_API,
  // 超时时间 单位是ms，这里设置了3s的超时时间
  timeout: 20 * 1000,
  withCredentials: true
})
// 超时时间
// axios.defaults.timeout = 100000
// 跨域请求，允许保存cookie
// axios.defaults.withCredentials = true
// axios.defaults.headers = {'Content-Type': 'application/json; charset=utf-8'}
// axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded; charset=utf-8'
// 非生产环境 && 开启代理, 接口前缀统一使用[/api]前缀做代理拦截!
// axios.defaults.baseURL = '/api'

/**
 * 请求拦截
 */
service.interceptors.request.use(config => {
  // showLoading()
  // 请求头带上token
  // config.headers.token = Vue.cookie.get('token')
  // 请求地址处理
  const type = config.method
  const defaults = {}
  const arrayFormat = config.headers.arrayFormat || 'indices'
  if (type === 'post') {
    // post请求参数处理
    config.data = qs.stringify(config.data, { allowDots: true, arrayFormat: arrayFormat })
  } else if (type === 'get') {
    // get请求参数处理
    config.params = qs.stringify(config.params, { allowDots: true, arrayFormat: arrayFormat })
    config.params = qs.parse(config.params)
    config.params = merge(defaults, config.params)
  }
  return config
}, error => {
  return Promise.reject(error)
})

/**
 * 响应拦截
 */
service.interceptors.response.use(response => {
  return response
}, error => {
  return Promise.reject(error)
})

export default service



// WEBPACK FOOTER //
// ./src/utils/http/httpRequest.js